// Demo site (Try Teamio) — the two public demo pages (plan Task 6.3) and the guard that keeps a demo session out of
// the pages hidden from it (Task 6.5). Added with router.addRoute / router.beforeEach from here, NOT in the
// `routes: [...]` table in src/Routes.js, so the real route table that
// cypress/node-tests/demo-real-user-ui-baseline.test.js pins stays exactly as it was.
import store from '@/store';
import DemoLanding from './DemoLanding.vue';
import TryTeamio from './TryTeamio.vue';
import { isRouteHiddenInDemo, demoHiddenRedirect } from '@/utils/demo/demoHidden';

export const DEMO_ROUTES = [
  {
    path: '/demo',
    name: 'DemoLanding',
    component: DemoLanding,
    meta: { requiresAuth: false }
  },
  {
    path: '/try',
    name: 'TryTeamio',
    component: TryTeamio,
    meta: { requiresAuth: false }
  },
];

function readRedirectPath() {
  try { return localStorage.getItem('redirectPath'); } catch (e) { return null; }
}

// Runs after the guards Routes.js registers. A real practice (isDemo false) always passes straight through.
export function installDemoRouteGuard(router, isDemo) {
  router.beforeEach((to, from, next) => {
    if (!isRouteHiddenInDemo(to, isDemo())) return next();
    return next(demoHiddenRedirect(from, readRedirectPath()));
  });
}

export function addDemoRoutes(router) {
  DEMO_ROUTES.forEach((route) => router.addRoute(route));
  installDemoRouteGuard(router, () => store.getters['customer/isDemo'] === true);
}
